import { getRootContextPath } from '../context-path';

export type CallbackFunction<ResponseType> = (response: ResponseType, status: number, next: NextFunction) => void;
export type NextFunction = () => void;

export class PollRequest<ResponseType> {
  private route: string;
  private interval: number;
  private running = false;

  public constructor(route: string, interval: number) {
    this.route = route;
    this.interval = interval;
    this.startPolling = this.startPolling.bind(this);
    this.stopPolling = this.stopPolling.bind(this);
    this.poll = this.poll.bind(this);
  }

  public startPolling(callback: CallbackFunction<ResponseType>) {
    this.running = true;
    this.poll(callback);
  }

  public stopPolling() {
    this.running = false;
  }

  private async poll(callback: CallbackFunction<ResponseType>) {
    const result = await fetch(getRootContextPath() + this.route, {
      method: 'GET',
      credentials: 'include'
    });

    const response = await result.json();

    callback(response, result.status, () => {
      setTimeout(() => {
        if (this.running) {
          this.poll(callback);
        }
      }, this.interval);
    });
  }
}
